import { useEffect } from "react";
import {
  Admin,
  Resource,
  StoreContextProvider,
  localStorageStore,
  // radiantDarkTheme,
  // radiantLightTheme,
  useStore,
} from "react-admin";
import { QueryClientProvider } from 'react-query';
import queryClient from './queryClient';
import authProvider from "./authProvider";
import dataProvider from "./dataProvider";
import CoAList from "./pages/coa/CoAList";
import UserList from "./pages/users/UserList";
import ActivityList from "./pages/activities/ActivityList";
import PrintHistoryList from "./pages/invoicePrintHistories/InvoicePrintHistoryList";
import SalesAreaList from "./pages/salesAreas/SalesAreaList";
import Welcome from "./pages/dashboard/Welcome";
import CompanyList from "./pages/companies/CompanyList";
import BrandList from "./pages/brands/BrandList";
import SizeList from "./pages/sizes/SizeList";
import ColorList from "./pages/colors/ColorList";
import QualityList from "./pages/qualities/QualityList";
import ProductList from "./pages/products/ProductList";
import BrandPriceAdditionList from "./pages/brandPriceAdditions/BrandPriceAdditionList";
import SizePriceAdditionList from "./pages/sizePriceAdditions/SizePriceAdditionList";
import PriceList from "./pages/prices/PriceList";
import PriceLimitList from "./pages/priceLimits/PriceLimitList";
import DensityList from "./pages/densities/DensityList";
import MotifList from "./pages/motifs/MotifList";
import KindList from "./pages/kinds/KindList";
import SupplierList from "./pages/suppliers/SupplierList";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SalesmanList from "./pages/salesmen/SalesmanList";
import WarehouseList from "./pages/warehouses/WarehouseList";
import TransportList from "./pages/transports/TransportList";
import PromotionList from "./pages/promotions/PromotionList";
import PurchaseOrderList from "./pages/purchaseOrders/PurchaseOrderList";
import PurchaseList from "./pages/purchases/PurchaseList";
import PurchaseReturnList from "./pages/purchaseReturns/PurchaseReturnList";
import SaleReturnList from "./pages/saleReturns/SaleReturnList";
import SaleOrderList from "./pages/saleOrders/SaleOrderList";
import SaleList from "./pages/sales/SaleList";
import SalesmanTargetList from "./pages/salesmanTargets/SalesmanTargetList";
import SalesmanIncentiveRateRuleList from "./pages/salesmanIncentiveRateRules/SalesmanIncentiveRateRuleList";
import CustomerTypeList from "./pages/customerTypes/CustomerTypeList";
import CustomerList from "./pages/customers/CustomerList";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import CropIcon from "@mui/icons-material/Crop";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import OpacityIcon from "@mui/icons-material/Opacity";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import FiberManualRecordOutlinedIcon from "@mui/icons-material/FiberManualRecordOutlined";
import GradeIcon from "@mui/icons-material/Grade";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import MyLayout from "./components/layout/Layout";
import { i18nProvider } from "./i18nProvider";
import FactoryDebtPaymentList from "./pages/factoryDebtPayments/FactoryDebtPaymentList";
import FactoryDebtCorrectionList from "./pages/factoryDebtCorrections/FactoryDebtCorrectionList";
import CustomerDebtPaymentList from "./pages/customerDebtPayments/CustomerDebtPaymentList";
import CustomerDebtCorrectionList from "./pages/customerDebtCorrections/CustomerDebtCorrectionList";
import CheckCashingList from "./pages/checkCashings/CheckCashingList";
import JournalList from "./pages/journals/JournalList";
import BadDebtList from "./pages/badDebts/BadDebtList";
import BadDebtInstallmentList from "./pages/badDebtInstallments/BadDebtInstallmentList";
import BadDebtCorrectionList from "./pages/badDebtCorrections/BadDebtCorrectionList";
import BadDebtCheckCashingList from "./pages/badDebtCheckCashings/BadDebtCheckCashingList";
import MutationRepackingList from "./pages/mutationRepackings/MutationRepackingList";
import MutationInventoryWriteOffList from "./pages/mutationInventoryWriteOffs/MutationInventoryWriteOffList";
import AllTransactionJournalList from "./pages/allTransactionJournals/AllTransactionJournalList";
import IncomeStatementList from "./pages/incomeStatements/IncomeStatementList";
import GeneralLedgerList from "./pages/generalLedgers/GeneralLedgerList";
import InventoryPendingList from "./pages/inventoryPendings/InventoryPendingList";
import GeneralLedgerShow from "./pages/generalLedgers/GeneralLedgerShow";
import BalanceSheetsList from "./pages/balanceSheets/BalanceSheetsList";
import RoleList from "./pages/roles/RoleList";
import RoleEdit from "./pages/roles/RoleEdit";
import RoleCreate from "./pages/roles/RoleCreate";
import PermissionList from "./pages/permissions/PermissionList";
import PermissionEdit from "./pages/permissions/PermissionEdit";
import PermissionCreate from "./pages/permissions/PermissionCreate";
import CloseBookList from "./pages/closeBooks/CloseBookList";
import AccountReceivableCardList from "./pages/accountReceivableCards/AccountReceivableCardList";
import LoginPage from "./pages/login/LoginPage";
import AccountPayableCardList from "./pages/accountPayableCards/AccountPayableCardList";
import InventoryCardList from "./pages/inventoryCards/InventoryCardList";
import PurchaseNetCardList from "./pages/purchaseNetCards/PurchaseNetCardList";
import PurchaseReturnCardList from "./pages/purchaseReturnCards/PurchaseReturnCardList";
import SaleReturnCardList from "./pages/saleReturnCards/SaleReturnCardList";
import SaleNetCardList from "./pages/saleNetCards/SaleNetCardList";
import InventoryAgeList from "./pages/inventoryAges/InventoryAgeList";
import AccountReceivableAgingList from "./pages/accountReceivableAgings/AccountReceivableAgingList";
import AccountReceivablePcmList from "./pages/accountReceivablePcms/AccountReceivablePcmList";
import AccountReceivableHistoryList from "./pages/accountReceivableHistories/AccountReceivableHistoryList";
import AccountReceivablePcmCardList from "./pages/accountReceivablePcmCards/AccountReceivablePcmCardList";
import AccountReceivablePcmAgeList from "./pages/accountReceivablePcmAges/AccountReceivablePcmAgeList";
import AccountPayableAgeList from "./pages/accountPayableAges/AccountPayableAgeList";
import AccountPayableHistoryList from "./pages/accountPayableHistories/AccountPayableHistoryList";
import InventoryHistoryList from "./pages/inventoryHistories/InventoryHistoryList";
import SaleRankingList from "./pages/saleRankings/SaleRankingList";
import ProductRankingList from "./pages/productRankings/ProductRankingList";
import CustomerRankingList from "./pages/customerRankings/CustomerRankingList";
import RestockPlanList from "./pages/restockPlans/RestockPlanList";
import { Icon } from "@iconify-icon/react";
import CategoryList from "./pages/categories/CategoryList";
import AccountReceivablePaymentList from "./pages/accountReceivablePayments/AccountReceivablePaymentList";
import AccountReceivableCorrectionList from "./pages/accountReceivableCorrections/AccountReceivableCorrectionList";
import { themes } from "./components/themeSwapper/themes";
import SettingList from "./pages/settings/SettingList";
import JournalMemorialList from "./pages/journalMemorials/JournalMemorialList";
import PurchaseGoodsInTransitList from "./pages/purchaseGoodsInTransits/PurchaseGoodsInTransitList";
import AccountPayablePaymentList from "./pages/accountPayablePayments/AccountPayablePaymentList";
import AccountPayableCorrectionList from "./pages/accountPayableCorrections/AccountPayableCorrectionList";
import InventoryRepackingList from "./pages/inventoryRepackings/InventoryRepackingList";
import InventoryWriteOffList from "./pages/inventoryWriteOffs/InventoryWriteOffList";
import ReceivedCheckList from "./pages/receivedChecks/ReceivedCheckList";
import CashedReturnedChecksList from "./pages/cashedReturnedChecks/CashedReturnedChecksList";
import CostOfGoodsSoldList from "./pages/costOfGoodsSolds/CostOfGoodsSoldList";
import AccountReceivableDabDebtHistoriesList from "./pages/accountReceivableDabDebtHistories/AccountReceivableDabDebtHistoriesList";
import CustomerListList from "./pages/customerLists/CustomerListList";
import TransactionHistoryList from "./pages/transactionHistories/TransactionHistoryList";
import CustomerMembershipList from "./pages/customerMemberships/CustomerMembershipList";
import AccountReceivablePcmOverviewList from "./pages/accountReceivablePcmOverviews/AccountReceivablePcmOverviewList";
import SalesmanIncentiveList from "./pages/salesmanIncentives/SalesmanIncentiveList";
import SalesmanJournalList from "./pages/salesmanJournals/SalesmanJournalList";
import SalesmanPenaltyDetailList from "./pages/salesmanPenaltyDetails/SalesmanPenaltyDetailList";
import SyncPropagationList from "./pages/syncPropagation/SyncPropagationList";
import SyncPullList from "./pages/syncPull/SyncPullList";
import SyncMonitorList from "./pages/syncMonitor/SyncMonitorList";
import SyncQueueList from "./pages/syncMonitor/SyncQueueList";
import SyncHistoryList from "./pages/syncMonitor/SyncHistoryList";

// import logo from "./logo.svg";
// import "./App.css";
// import CoACreate from "./pages/coa/CoACreate";
// import BannerEdit from "./pages/banners/BannerEdit";
// import UserCreate from "./pages/users/UserCreate";
// import UserEdit from "./pages/users/UserEdit";
// import UserShow from "./pages/users/UserShow";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import LocationCityIcon from "@mui/icons-material/LocationCity";
// import AccountTreeIcon from "@mui/icons-material/AccountTree";
// import ShareLocationIcon from "@mui/icons-material/ShareLocation";
// import ManIcon from "@mui/icons-material/Man";
// import DiscountIcon from "@mui/icons-material/Discount";
// import WarehouseIcon from "@mui/icons-material/Warehouse";
// import FireTruckIcon from "@mui/icons-material/FireTruck";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import StoreIcon from "@mui/icons-material/Store";
// import DifferenceIcon from "@mui/icons-material/Difference";
// import MoneyIcon from "@mui/icons-material/Money";
// import CategoryIcon from "@mui/icons-material/Category";
// import PriceChangeIcon from "@mui/icons-material/PriceChange";
// import PriceCheckIcon from "@mui/icons-material/PriceCheck";
// import PendingIcon from "@mui/icons-material/Pending";
// import BookIcon from "@mui/icons-material/Book";
// import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
// import PaymentsIcon from "@mui/icons-material/Payments";
// import BalanceIcon from "@mui/icons-material/Balance";
// import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
// import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
// import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
// import BalanceMyIcon from "./components/myIcons/BalanceMyIcon";
// import BookMyIcon from "./components/myIcons/BookMyIcon";

// const darkTheme = {
//   ...defaultTheme,
//   palette: { mode: "dark" },
// };

// setiap deploy baru versinya perlu dirubah
// tergantung kebutuhan, tp sebaiknya di rubah saja
const STORE_VERSION = "9"; // see: https://marmelab.com/react-admin/Store.html#store-invalidation

const store = localStorageStore(STORE_VERSION, "Acura");

const App = () => {
  useEffect(() => {
    const blurFocusedNumberInput = () => {
      const activeElement = document.activeElement;

      if (!(activeElement instanceof HTMLInputElement)) {
        return;
      }

      if (activeElement.type !== "number") {
        return;
      }

      activeElement.blur();
    };

    document.addEventListener("wheel", blurFocusedNumberInput, true);

    return () => {
      document.removeEventListener("wheel", blurFocusedNumberInput, true);
    };
  }, []);

  const [themeName] = useStore("themeName", "radiant");
  const ble = themes.find((theme) => theme.name === themeName);
  const lightTheme = ble ? ble.light : undefined;
  const darkTheme = ble ? ble.dark : undefined;

  return (
    <Admin
      store={store}
      disableTelemetry
      dashboard={Welcome}
      dataProvider={dataProvider}
      authProvider={authProvider}
      i18nProvider={i18nProvider}
      layout={MyLayout}
      loginPage={LoginPage}
      theme={lightTheme}
      lightTheme={lightTheme}
      darkTheme={darkTheme}
      defaultTheme="light"
      queryClient={queryClient}
    >
      {(permissions) => {
        return (
          <>
            <Resource
              name="companies"
              list={CompanyList}
              icon={() => (
                <Icon
                  icon="emojione:office-building"
                  style={{ fontSize: 26 }}
                />
              )}
              options={{ label: "resources.company.name" }}
              // edit={UserEdit}
              // create={UserCreate}
              // show={UserShow}
            />
            <Resource
              name="roles"
              list={RoleList}
              icon={() => (
                <Icon icon="fluent-emoji:blossom" style={{ fontSize: 26 }} />
              )}
              // options={{ label: "resources.role.name" }}
              edit={RoleEdit}
              create={RoleCreate}
            />
            <Resource
              name="permissions"
              list={PermissionList}
              icon={() => (
                <Icon icon="fluent-emoji:hamburger" style={{ fontSize: 26 }} />
              )}
              // options={{ label: "resources.permission.name" }}
              edit={PermissionEdit}
              create={PermissionCreate}
            />
            <Resource
              options={{ label: "resources.chart_of_account.name" }}
              name="coa"
              list={CoAList}
              icon={() => (
                <Icon icon="fluent-emoji:palm-tree" style={{ fontSize: 26 }} />
              )}
              // edit={CoAEdit}
              // create={CoACreate}
            />
            <Resource
              name="sales-areas"
              list={SalesAreaList}
              options={{ label: "resources.sales_area.name" }}
              icon={() => (
                <Icon
                  icon="fluent-emoji:triangular-flag"
                  style={{ fontSize: 26 }}
                />
              )}
            />
            <Resource
              name="customer-types"
              list={CustomerTypeList}
              icon={() => (
                <Icon icon="fluent-emoji:tiger-face" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.customer_type.name" }}
            />
            <Resource
              name="customers"
              list={CustomerList}
              icon={() => (
                <Icon icon="fluent-emoji:whale" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.customer.name" }}
            />
            <Resource
              name="suppliers"
              list={SupplierList}
              icon={() => (
                <Icon
                  icon="noto-v1:articulated-lorry"
                  style={{ fontSize: 26 }}
                />
              )}
              options={{ label: "resources.supplier.name" }}
            />
            <Resource
              name="categories"
              list={CategoryList}
              icon={() => (
                <Icon
                  icon="fluent-emoji:cut-of-meat"
                  style={{ fontSize: 26 }}
                />
              )}
              options={{ label: "resources.category.name" }}
            />
            <Resource name="customer-category-limits" />
            <Resource
              name="kinds"
              list={KindList}
              icon={() => (
                <Icon
                  icon="fluent-emoji:ear-of-corn"
                  style={{ fontSize: 26 }}
                />
              )}
              options={{ label: "resources.kind.name" }}
            />
            <Resource
              name="brands"
              list={BrandList}
              icon={BrandingWatermarkIcon}
              options={{ label: "resources.brand.name" }}
            />
            <Resource
              name="sizes"
              list={SizeList}
              icon={CropIcon}
              options={{ label: "resources.size.name" }}
            />
            <Resource name="motifs" list={MotifList} icon={AcUnitIcon} />
            <Resource
              name="densities"
              list={DensityList}
              icon={OpacityIcon}
              options={{ label: "resources.density.name" }}
            />
            <Resource
              name="colors"
              list={ColorList}
              icon={ColorLensIcon}
              options={{ label: "resources.color.name" }}
            />
            <Resource
              name="qualities"
              list={QualityList}
              icon={GradeIcon}
              options={{ label: "resources.quality.name" }}
            />
            <Resource
              name="products"
              list={ProductList}
              icon={() => (
                <Icon icon="fluent-emoji:softball" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.product.name" }}
            />
            <Resource
              name="prices"
              list={PriceList}
              icon={() => (
                <Icon icon="fluent-emoji:bookmark" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.price.name" }}
            />
            <Resource
              name="price-limits"
              list={PriceLimitList}
              icon={() => (
                <Icon
                  icon="fluent-emoji:bellhop-bell"
                  style={{ fontSize: 26 }}
                />
              )}
              options={{ label: "resources.price_limit.name" }}
            />
            <Resource
              name="brand-price-additions"
              list={BrandPriceAdditionList}
              icon={() => (
                <Icon icon="fluent-emoji:grapes" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.brand_price_addition.name" }}
            />
            <Resource
              name="size-price-additions"
              list={SizePriceAdditionList}
              icon={() => (
                <Icon icon="fluent-emoji:lime" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.size_price_addition.name" }}
            />
            <Resource
              name="promotions"
              list={PromotionList}
              options={{ label: "mine.label.promotions" }}
              icon={() => (
                <Icon
                  icon="fluent-emoji:party-popper"
                  style={{ fontSize: 26 }}
                />
              )}
            />
            <Resource
              name="salesmen"
              list={SalesmanList}
              options={{ label: "Salesmen" }}
              icon={() => (
                <Icon
                  icon="fluent-emoji:smiling-face-with-sunglasses"
                  style={{ fontSize: 26 }}
                />
              )}
            />
            <Resource
              name="salesman-targets"
              list={SalesmanTargetList}
              options={{ label: "Salesman Targets" }}
              icon={() => (
                <Icon icon="fluent-emoji:bug" style={{ fontSize: 26 }} />
              )}
            />
            <Resource
              name="salesman-incentive-rate-rules"
              list={SalesmanIncentiveRateRuleList}
              options={{ label: "Salesman Incentive Rate Rules" }}
              icon={() => (
                <Icon icon="fluent-emoji:money-bag" style={{ fontSize: 26 }} />
              )}
            />
            <Resource
              name="warehouses"
              list={WarehouseList}
              icon={() => (
                <Icon icon="fluent-emoji:tent" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.warehouse.name" }}
            />
            <Resource
              name="transports"
              list={TransportList}
              icon={() => (
                <Icon
                  icon="fluent-emoji:delivery-truck"
                  style={{ fontSize: 26 }}
                />
              )}
              options={{ label: "resources.transport.name" }}
            />
            <Resource
              name="users"
              list={UserList}
              icon={() => (
                <Icon icon="fluent-emoji-flat:crown" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.user.name" }}
              // edit={UserEdit}
              // create={UserCreate}
              // show={UserShow}
            />
            {permissions?.administrator && (
              <Resource
                name="sync-propagations"
                list={SyncPropagationList}
                icon={SyncAltIcon}
                options={{ label: "Sync Propagation" }}
              />
            )}
            {permissions?.administrator && (
              <Resource
                name="sync-monitor"
                list={SyncMonitorList}
                icon={SyncAltIcon}
                options={{ label: "Sync Monitor" }}
              />
            )}
            {permissions?.administrator && (
              <Resource name="sync-queue" list={SyncQueueList} icon={SyncAltIcon} options={{ label: "Sync Queue" }} />
            )}
            {permissions?.administrator && (
              <Resource name="sync-history" list={SyncHistoryList} icon={SyncAltIcon} options={{ label: "Sync History" }} />
            )}
            <Resource
              name="sync-pull"
              list={SyncPullList}
              icon={SyncAltIcon}
              options={{ label: "Sync Pull" }}
            />
            <Resource
              name="activities"
              list={ActivityList}
              icon={() => (
                <Icon
                  icon="fluent-emoji-flat:closed-mailbox-with-raised-flag"
                  style={{ fontSize: 26 }}
                />
              )}
              options={{ label: "resources.activity.name" }}
            />
            <Resource
              name="restock-plans"
              list={RestockPlanList}
              icon={() => (
                <Icon
                  icon="fluent-emoji:bow-and-arrow"
                  style={{ fontSize: 26 }}
                />
              )}
              options={{
                label: "resources.restock_plan.name",
              }}
            />
            <Resource
              name="purchase-orders"
              list={PurchaseOrderList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.order.name" }}
            />
            <Resource
              name="purchases"
              list={PurchaseList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.purchase.name" }}
            />
            <Resource
              name="purchase-returns"
              list={PurchaseReturnList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.return.name" }}
            />
            <Resource
              name="sale-orders"
              list={SaleOrderList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.order.name" }}
            />
            <Resource
              name="sales"
              list={SaleList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.sale.name" }}
            />
            <Resource
              name="sale-returns"
              list={SaleReturnList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.return.name" }}
            />
            <Resource
              name="factory-debt-payments"
              list={FactoryDebtPaymentList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.debt_payment.name" }}
            />
            <Resource
              name="factory-debt-corrections"
              list={FactoryDebtCorrectionList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.debt_correction.name" }}
            />
            <Resource
              name="customer-debt-payments"
              list={CustomerDebtPaymentList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.debt_payment.name" }}
            />
            <Resource
              name="customer-debt-corrections"
              list={CustomerDebtCorrectionList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.debt_correction.name" }}
            />
            <Resource
              name="check-cashings"
              list={CheckCashingList}
              icon={() => (
                <Icon
                  icon="fluent-emoji:dollar-banknote"
                  style={{ fontSize: "26px" }}
                />
              )}
              options={{ label: "resources.check_cashing.name" }}
            />
            <Resource
              name="journals"
              list={JournalList}
              icon={() => (
                <Icon icon="emojione-v1:newspaper" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.journal.name" }}
            />
            <Resource
              name="bad-debts"
              list={BadDebtList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.bad_debt.name" }}
            />
            <Resource
              name="bad-debt-installments"
              list={BadDebtInstallmentList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.bad_debt_installment.name" }}
            />
            <Resource
              name="bad-debt-corrections"
              list={BadDebtCorrectionList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.bad_debt_correction.name" }}
            />
            <Resource
              name="bad-debt-check-cashing"
              list={BadDebtCheckCashingList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.bad_debt_check_cashing.name" }}
            />
            <Resource
              name="mutation-repackings"
              list={MutationRepackingList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.mutation_repacking.name" }}
            />
            <Resource
              name="mutation-inventory-write-offs"
              list={MutationInventoryWriteOffList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.mutation_inventory_write_off.name",
              }}
            />
            <Resource
              name="received-checks"
              list={ReceivedCheckList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "mine.label.received",
              }}
            />
            <Resource
              name="cashed-returned-checks"
              list={CashedReturnedChecksList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "mine.label.cashed_returned",
              }}
            />
            <Resource
              name="inventory-pendings"
              list={InventoryPendingList}
              icon={() => (
                <Icon icon="twemoji:construction" style={{ fontSize: 26 }} />
              )}
              options={{ label: "resources.inventory_pending.name" }}
            />
            <Resource
              name="close-books"
              list={CloseBookList}
              icon={() => (
                <Icon icon="fluent-emoji:books" style={{ fontSize: "26px" }} />
              )}
              options={{ label: "resources.close_book.name" }}
            />

            <Resource
              name="balance-sheets"
              list={BalanceSheetsList}
              icon={() => (
                <Icon
                  icon="fluent-emoji:balance-scale"
                  style={{ fontSize: "26px" }}
                />
              )}
              options={{
                label: "resources.balance_sheets.name",
              }}
            />
            <Resource
              name="income-statements"
              list={IncomeStatementList}
              icon={() => (
                <Icon
                  icon="fluent-emoji:money-bag"
                  style={{ fontSize: "26px" }}
                />
              )}
              options={{
                label: "resources.income_statements.name",
              }}
            />
            <Resource
              name="cost-of-goods-solds"
              list={CostOfGoodsSoldList}
              icon={() => (
                <Icon
                  icon="fluent-emoji-flat:grapes"
                  style={{ fontSize: "26px" }}
                />
              )}
              options={{
                label: "resources.cost_of_goods_solds.name",
              }}
            />
            <Resource
              name="general-ledgers"
              list={GeneralLedgerList}
              show={GeneralLedgerShow}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.general_ledgers.name",
              }}
            />
            <Resource
              name="purchase-net-cards"
              list={<PurchaseNetCardList title="mine.label.net_purchase" />}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "mine.label.net",
              }}
            />
            <Resource
              name="purchase-cards"
              list={<PurchaseList title="mine.label.gross_purchase" />}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "mine.label.gross",
              }}
            />
            <Resource
              name="purchase-return-cards"
              list={PurchaseReturnCardList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.return.name",
              }}
            />
            <Resource
              name="purchase-goods-in-transits"
              list={PurchaseGoodsInTransitList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "Goods in Transit",
              }}
            />
            <Resource
              name="sale-net-cards"
              list={<SaleNetCardList title="mine.label.net_sale" />}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "mine.label.net",
              }}
            />
            <Resource
              name="sale-cards"
              list={<SaleList title="mine.label.gross_sale" />}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "mine.label.gross",
              }}
            />
            <Resource
              name="sale-return-cards"
              list={SaleReturnCardList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.return.name",
              }}
            />
            <Resource
              name="sale-rankings"
              list={SaleRankingList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.ranking.name",
              }}
            />
            <Resource
              name="account-receivable-payments"
              list={AccountReceivablePaymentList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_payments.name",
              }}
            />
            <Resource
              name="account-receivable-corrections"
              list={AccountReceivableCorrectionList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_corrections.name",
              }}
            />
            <Resource
              name="account-receivable-cards"
              list={AccountReceivableCardList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_cards.name",
              }}
            />
            <Resource
              name="account-receivable-agings"
              list={AccountReceivableAgingList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_agings.name",
              }}
            />
            <Resource
              name="account-receivable-histories"
              list={AccountReceivableHistoryList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_histories.name",
              }}
            />
            <Resource
              name="account-receivable-pcms"
              list={AccountReceivablePcmList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_pcms.name",
              }}
            />
            <Resource
              name="account-receivable-pcm-cards"
              list={AccountReceivablePcmCardList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_pcm_cards.name",
              }}
            />
            <Resource
              name="account-receivable-pcm-ages"
              list={AccountReceivablePcmAgeList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_pcm_ages.name",
              }}
            />
            <Resource
              name="account-receivable-pcm-overviews"
              list={AccountReceivablePcmOverviewList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_pcm_overviews.name",
              }}
            />
            <Resource
              name="account-receivable-bad-debt-histories"
              list={AccountReceivableDabDebtHistoriesList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_receivable_bad_debt_histories.name",
              }}
            />
            <Resource
              name="account-payable-payments"
              list={AccountPayablePaymentList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_payable_payments.name",
              }}
            />
            <Resource
              name="account-payable-corrections"
              list={AccountPayableCorrectionList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_payable_corrections.name",
              }}
            />
            <Resource
              name="account-payable-cards"
              list={AccountPayableCardList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_payable_cards.name",
              }}
            />
            <Resource
              name="account-payable-ages"
              list={AccountPayableAgeList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_payable_ages.name",
              }}
            />
            <Resource
              name="account-payable-histories"
              list={AccountPayableHistoryList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.account_payable_histories.name",
              }}
            />
            <Resource
              name="inventory-cards"
              list={InventoryCardList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.inventory_cards.name",
              }}
            />
            <Resource
              name="inventory-ages"
              list={InventoryAgeList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.inventory_ages.name",
              }}
            />
            <Resource
              name="inventory-histories"
              list={InventoryHistoryList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.inventory_histories.name",
              }}
            />
            <Resource
              name="inventory-repackings"
              list={InventoryRepackingList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.inventory_repackings.name",
              }}
            />
            <Resource
              name="inventory-write-offs"
              list={InventoryWriteOffList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.inventory_write_offs.name",
              }}
            />
            <Resource
              name="product-rankings"
              list={ProductRankingList}
              icon={() => (
                <Icon icon="fluent-emoji:candy" style={{ fontSize: 26 }} />
              )}
              options={{
                label: "resources.product_rankings.name",
              }}
            />
            <Resource
              name="transaction-histories"
              list={TransactionHistoryList}
              icon={() => (
                <Icon icon="fluent-emoji:bubble-tea" style={{ fontSize: 26 }} />
              )}
              options={{
                label: "resources.transaction_histories.name",
              }}
            />
            <Resource
              name="print-histories"
              list={PrintHistoryList}
              icon={() => (
                <Icon icon="fluent-emoji:printer" style={{ fontSize: 26 }} />
              )}
              options={{
                label: "resources.print_histories.name",
              }}
            />
            <Resource
              name="customer-lists"
              list={CustomerListList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.customer_lists.name",
              }}
            />
            <Resource
              name="customer-rankings"
              list={CustomerRankingList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.customer_rankings.name",
              }}
            />
            <Resource
              name="customer-memberships"
              list={CustomerMembershipList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.customer_memberships.name",
              }}
            />
            <Resource
              name="salesman-incentives"
              list={SalesmanIncentiveList}
              icon={FiberManualRecordOutlinedIcon}
              options={{ label: "resources.salesman_incentives.name" }}
            />
            <Resource
              name="salesman-journals"
              list={SalesmanJournalList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.salesman_journals.name",
              }}
            />
            <Resource
              name="salesman-penalty-details"
              list={SalesmanPenaltyDetailList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.salesman_penalty_details.name",
              }}
            />
            <Resource
              name="all-transaction-journals"
              list={AllTransactionJournalList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.all_transaction_journals.name",
              }}
            />
            <Resource
              name="journal-memorials"
              list={JournalMemorialList}
              icon={FiberManualRecordOutlinedIcon}
              options={{
                label: "resources.journal_memorials.name",
              }}
            />
            <Resource
              name="settings"
              list={SettingList}
              icon={() => (
                <Icon
                  icon="fluent-emoji:hammer-and-wrench"
                  style={{ fontSize: 26 }}
                />
              )}
              options={{
                label: "resources.settings.name",
              }}
            />
          </>
        );
      }}
    </Admin>
  );
};

const AppWrapper = () => (
  <StoreContextProvider value={store}>
    <App />
  </StoreContextProvider>
);

export default AppWrapper;
